import { Box, BoxProps, Heading, useTheme } from '@hover/blueprint';
import { space } from '@hover/blueprint/foundation';
import React from 'react';

interface ListProps extends BoxProps {
  children: React.ReactNode[];
  title: string;
}

const List = ({ title, children, marginBottom = 500, ...props }: ListProps) => {
  const {
    space: { 400: panelPadding },
  } = useTheme();

  return (
    <Box display="block" marginBottom={marginBottom} {...props}>
      <Heading marginBottom={300} size={200}>
        {title}
      </Heading>
      <Box
        marginX={`-${space[400]}`}
        overflow="scroll"
        paddingBottom={400}
        paddingLeft={400}
        paddingRight={400}
        paddingTop={100}
        panelPadding={panelPadding}
      >
        <Box paddingRight={400}>{children}</Box>
      </Box>
    </Box>
  );
};

export { List };
